import angular from "angular"
import "../authentication/authentication"

export default angular.module("currentUserModule", ["authentication"])